module.exports = __webpack_public_path__ + "img/shouyin_active.68c761ea.png";